import React, { Fragment, useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import _ from "lodash";
import moment from "moment";
import AppointmentForm from "../TrackAppointment/AppointmentForm";
import ManageTasksForm from "../Forms/ManageTasksForm";
import {
  createAppointmentNotesService,
  deleteAppointmentService,
  informAppointmentDeletion,
  sendSMSService,
  updateTasksService,
} from "../../services/workflow";
import { formatDateTime } from "../../utils";
import { setAppointmentRequests, setDisplayArchiveOnly, setPageSize } from "./appointmentRequestSlice";
import { aptRequestClientTab, AUTO_SMS_KEY } from "../../constants";
import {
  appointmentDateFieldFilter,
  caseManagerFieldFilter,
  creationDateTimeFieldFilter,
  dateFieldFilter,
  generalFieldFilter,
  referrerFieldFilter,
  usernameFieldFilter,
} from "../Workflow/filters/fieldFilter";
import getReferrerFullName from "../Workflow/services/getReferrerFullName";
import getCaseManagerById from "../Workflow/services/getCaseManagerById";
import getSMSLogs, { getSMSLogsWithHistory } from "../Workflow/services/getSMSLogs";
import { generateCreationTimestamp, getRemainingWeeksToAppointment } from "../Workflow/utils";
import { BOOKING_STATUS, CREATION_TIME_SECTION } from "../Workflow/constants";
import { approveAppointmentRequestService } from "../../services/appointmentRequests";
import { WORKFLOW_NAME } from "../constant";
import { downloadReferralLetter, fetchReferralLetter } from "../../services/referralLetters";
import DeleteWorkflowForm from "../Forms/DeleteWorkflowForm";
import ManualSms from "../Workflow/components/ManualSms";
import { NEW_BOOKING_STATUS_CLASSES_MAP } from "../constant";

import { displayDateTime, displayTimestamp } from "../../utils/dateDisplay";
// export const TASK_STATUS_CLASSES_MAP = {
//   NS: "has-background-danger has-text-white",
//   PD: "has-background-warning has-text-white",
//   CP: "has-background-success has-text-white",
//   WL: "has-background-link has-text-white",
// };

const isDataFromPMS = process.env.REACT_APP_DATA_SOURCE === "pms-api";

const getTaskStatusClasses = (status) => {
  const MAP = {
    // ...TASK_STATUS_CLASSES_MAP,
    ...NEW_BOOKING_STATUS_CLASSES_MAP,
  };
  const className = MAP[status];
  return className ?? "has-background-warning has-text-white px-2";
};

const mapStateToProps = (state) => ({
  clientAppointmentRequests: state.appointmentRequests.clientAppointmentRequests,
  pageSize: state.appointmentRequests.pageSize,
  practitioners: state.app.practitioners,
  referrers: state.app.referrers,
  displayArchiveOnly: state.appointmentRequests.displayArchiveOnly,
});

const mapDispatchToProps = { setPageSize, setDisplayArchiveOnly, setAppointmentRequests };

const AppointmentRequests = ({
  practitioners,
  referrers,
  clientAppointmentRequests,
  pageSize,
  setPageSize,
  setAppointmentRequests,
}) => {
  const practitionerPreferences = useSelector(({ app }) => app?.practitionerPreferences);
  const [activeCa, setActiveCa] = useState(null);
  const [activeCaId, setActiveCaId] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [caData, setCaData] = useState([]);
  const [inAction, setInAction] = useState(false);
  const [actionSuccess, setActionSuccess] = useState(null);
  const [modalFormName, setModalFormName] = useState("");
  const [isDownloadingReferral, setIsDownloadingReferral] = useState(false);

  const [specialityFilter, setSpecialityFilter] = useState("");

  const [clientFilter, setClientFilter] = useState("");
  const [dobFilter, setDobFilter] = useState("");
  const [creationDateTimeFilter, setCreationDateTimeFilter] = useState("");
  const [appointmentDateFilter, setAppointmentDateFilter] = useState("");
  const [referrerFilter, setReferrerFilter] = useState("");
  const [caseManagerFilter, setCaseManagerFilter] = useState("");
  const [clinicFilter, setClinicFilter] = useState("");
  const [appointmentFilter, setAppointmentFilter] = useState("");
  const [preConsultFilter, setPreConsultFilter] = useState("");
  const [letterFilter, setLetterFilter] = useState("");
  const [bookingStatusFilter, setBookingStatusFilter] = useState("");
  const [displayDropdownList, setDisplayDropdownList] = useState(false);
  const [timeType, setTimeType] = useState(CREATION_TIME_SECTION.CREATION_TIME);

  const [currentPageIndex, setCurrentPageIndex] = useState(0);
  const [totalNumOfRows, setTotalNumOfRows] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [pageFrom, setPageFrom] = useState(1);
  const [pageTo, setPageTo] = useState(10);

  const [workflowSelectedTabId, setWorkflowSelectedTabId] = useState("logs");

  const [sortColumns, setSortColumns] = useState([
    {
      column: "creationTimestamp",
      order: false,
      isCurrentClickedColumn: true,
    },
  ]);

  useEffect(() => {
    setSortColumns([
      {
        column: "creationTimestamp",
        order: false,
        isCurrentClickedColumn: true,
      },
    ]);
  }, []);

  const handleCloseModal = () => {
    setOpenModal(false);
    setModalFormName("");
    setActionSuccess(null);
    setInAction(false);
  };

  const handleClickDelete = async () => {
    setOpenModal(true);
    setModalFormName("delete_apt");
  };

  const renderManualSMSStatus = (id) => {
    const ca = _.find(clientAppointmentRequests, (ca) => ca.id === id);
    const manual_sms = _.get(ca, "manual_sms");

    if (!manual_sms) {
      return null;
    }

    const { sent, received } = manual_sms;
    let className = "";

    if (sent) {
      className = "";
    }

    if (received) {
      className = "has-text-primary";
    }

    return (
      <span key={id} className={`${className} icon is-small`}>
        <i className="fas fa-circle" />
      </span>
    );
  };

  /**
   * 0: not sent
   * 1: sent but no yes or no response
   * 2: sent with yes response
   * 3: sent with no response
   */
  const getReceivedYesStatus = (id) => {
    const renderMark = (status, key) => {
      let className = "";
      switch (status) {
        case "":
          className = "has-text-link";
          break;
        case "yes":
          className = "has-text-success";
          break;
        case "no":
          className = "has-text-danger";
          break;
        case "no_response":
          className = "has-text-warning";
          break;
        default:
      }
      //return <span key={key} className={className}>#</span>;
      return (
        <span key={key} className={`${className} icon is-small`}>
          <i className="fas fa-circle" />
        </span>
      );
    };

    const apt = () => {
      const ca = _.find(clientAppointmentRequests, (ca) => ca.id === id);
      return _.get(ca, "appointment", _.get(ca, "pendingAppointment", null));
    };

    if (!apt()) {
      return null;
    }

    const logs = getSMSLogs(id, clientAppointmentRequests, "sms");
    if (_.isEmpty(logs)) return "";

    let which = "";
    let result = {};
    for (let idx = 0; idx < logs.length; idx++) {
      if (logs[idx]?.name) {
        which = _.startsWith(logs[idx].name, "initial") ? AUTO_SMS_KEY.INITIAL : logs[idx].name;
        result[which] = "";
      }

      if (logs[idx]?.name === AUTO_SMS_KEY.INITIAL_SECOND) {
        // if there is no received yes or no at 8 hours after initial second sms, treat it as patient says no
        if (moment().diff(moment.unix(logs[idx].ts), "hours") >= 8) {
          result[which] = "no_response";
        }
      }

      if (logs[idx].patient) {
        if (logs[idx].text.replace(/(\r\n|\n|\r)/gm, " ").search(/\byes\b|\by\b/gi) !== -1) {
          result[which] = "yes";
        } else if (logs[idx].text.replace(/(\r\n|\n|\r)/gm, " ").search(/\bno\b|\bn\b/gi) !== -1) {
          result[which] = "no";
        }
      }
    }

    return [
      renderMark(_.get(result, AUTO_SMS_KEY.INITIAL, null), 0),
      renderMark(_.get(result, AUTO_SMS_KEY.SECOND, null), 1),
      renderMark(_.get(result, AUTO_SMS_KEY.THIRD, null), 2),
      renderMark(_.get(result, AUTO_SMS_KEY.FOURTH, null), 3),
    ];
  };

  const renderIVRIcon = (id) => {
    const appointment = _.get(
      _.find(clientAppointmentRequests, (ca) => ca.id === id),
      "appointment",
      null
    );

    if (!appointment) {
      return null;
    }

    const ivr = _.get(
      _.find(clientAppointmentRequests, (ca) => ca.id === id),
      "ivr",
      null
    );

    let className = "",
      key = 0;

    if (ivr && ivr.reply === "1") {
      className = "has-text-success";
      key = 1;
    }

    if (ivr && ivr.reply === "2") {
      className = "has-text-warning";
      key = 2;
    }

    if (ivr && !ivr.reply && ["completed", "no-answer"].includes(ivr.status)) {
      className = "has-text-danger";
      key = 3;
    }

    return (
      <Fragment>
        <span className="dash">-</span>
        <span key={key} className={`${className} icon is-small`}>
          <i className="fas fa-circle" />
        </span>
      </Fragment>
    );
  };

  const handleAddAppointment = (bookingStatus) => async (appointment) => {
    setInAction(true);
    try {
      await approveAppointmentRequestService({
        id: activeCa.id,
        appointment,
      });
      await createAppointmentNotesService({
        notes: appointment.notes,
        id: activeCa.id,
      });

      if (activeCa.bookingStatus === bookingStatus) {
        setInAction(false);
        return;
      }

      const aptRequests = [...clientAppointmentRequests];
      const index = aptRequests.findIndex((ca) => ca.id === activeCa.id);
      aptRequests.splice(index, 1);
      setAppointmentRequests({ clientAppointmentRequests: aptRequests });
      setActionSuccess(true);
    } catch (error) {
      setActionSuccess(false);
      return error;
    } finally {
      setInAction(false);
    }
  };

  const handleInformDeletion = async (data) => {
    setInAction(true);
    try {
      await informAppointmentDeletion(data);
      setActionSuccess(true);
    } catch (error) {
      setActionSuccess(false);
    } finally {
      setInAction(false);
    }
  };

  const handleDeleteAppointment = (id) => async (appointmentId) => {
    setInAction(true);
    try {
      await deleteAppointmentService({ id, appointmentId });
      setActionSuccess(true);
    } catch (error) {
      setActionSuccess(false);
    } finally {
      setInAction(false);
    }
  };

  const handleClickAddAppointment = async () => {
    setOpenModal(true);
    setModalFormName("add_appointment");
  };

  const handleSendSMSMessage = async (message) => {
    setInAction(true);
    const { phoneNumberMobile, firstName, lastName } = activeCa.client;
    try {
      await sendSMSService({
        id: activeCa.id,
        phoneNumber: phoneNumberMobile,
        patientFullName: `${firstName} ${lastName}`,
        template: message,
      });

      setActionSuccess(true);
    } catch (error) {
      setActionSuccess(false);
    } finally {
      setInAction(false);
    }
  };

  const handleClickManageTasks = () => {
    setOpenModal(true);
    setModalFormName("manage_tasks");
  };

  const handleManageTasks = (id) => async (tasks) => {
    setInAction(true);
    try {
      await updateTasksService({ id, tasks, workflowName: WORKFLOW_NAME.APT_REQUESTS });
      const activeTemp = { ...activeCa };
      activeTemp.appointment_t = tasks.appointment_t;
      activeTemp.letter_t = tasks.letter_t;
      activeTemp.pre_consult_t = tasks.pre_consult_t;
      setActiveCa(activeTemp);
      const aptRequests = [...clientAppointmentRequests];
      const index = aptRequests.findIndex((ca) => ca.id === activeTemp.id);
      aptRequests.splice(index, 1, activeTemp);
      setAppointmentRequests({ clientAppointmentRequests: aptRequests });
      setActionSuccess(true);
    } catch (error) {
      setActionSuccess(false);
    } finally {
      setInAction(false);
    }
  };

  const getTasks = () => {
    const clientApt = clientAppointmentRequests.find((ca) => ca.id === activeCa.id);
    const { appointment_t, letter_t, pre_consult_t } = clientApt;
    return {
      appointment_t: {
        coordinator: _.get(appointment_t, "coordinator", ""),
        status: _.get(appointment_t, "status", ""),
        notes: _.get(appointment_t, "notes", ""),
        urgent: _.get(appointment_t, "urgent", false),
        name_referral: _.get(appointment_t, "name_referral", false),
        weeks_to_appointment: _.get(appointment_t, "weeks_to_appointment", ""),
        expected_appointment_date: _.get(appointment_t, "expected_appointment_date", null),
        is_new_appointment: _.get(appointment_t, "is_new_appointment", false),
        cont_or_tbc: _.get(appointment_t, "cont_or_tbc", ""),
        triage: _.get(appointment_t, "triage", false),
      },
      letter_t: {
        coordinator: _.get(letter_t, "coordinator", ""),
        status: _.get(letter_t, "status", ""),
        notes: _.get(letter_t, "notes", ""),
        urgent: _.get(letter_t, "urgent", false),
      },
      pre_consult_t: {
        coordinator: _.get(pre_consult_t, "coordinator", ""),
        status: _.get(pre_consult_t, "status", ""),
        notes: _.get(pre_consult_t, "notes", ""),
        urgent: _.get(pre_consult_t, "urgent", false),
        inspections: _.get(pre_consult_t, "inspections", []),
      },
    };
  };

  const handleClickRow = async (id) => {
    setActiveCaId(id);
    setActiveCa(_.find(clientAppointmentRequests, (ca) => ca.id === id));
    setWorkflowSelectedTabId("logs");
  };

  const renderOrderArrow = (column) => {
    const sortColumn = _.find(sortColumns, { column });
    if (!sortColumn) {
      return null;
    }

    if (sortColumn.order) {
      return (
        <span className="icon is-small" key={`${sortColumn.column}-${sortColumn.order}`}>
          <i className="fa-arrow-up fas" />
        </span>
      );
    }

    if (!sortColumn.order) {
      return (
        <span className="icon is-small" key={`${sortColumn.column}-${sortColumn.order}`}>
          <i className="fas fa-arrow-down" />
        </span>
      );
    }
  };

  const handleSortingClick = (ob) => {
    const index = _.findIndex(sortColumns, { column: ob });
    const newSortColumns = sortColumns.map((sortColumn) => ({
      ...sortColumn,
      isCurrentClickedColumn: false,
    }));

    if (index < 0) {
      const data = [
        ...newSortColumns,
        {
          column: ob,
          order: false,
          isCurrentClickedColumn: true,
        },
      ];

      setSortColumns(data);
      return;
    }

    newSortColumns.splice(index, 1, {
      column: ob,
      order: !sortColumns[index].order,
      isCurrentClickedColumn: true,
    });

    setSortColumns([...newSortColumns]);
  };
  const handleClearAllSorts = () => {
    setSortColumns([]);
  };

  const renderCreationTimeSection = (ca) => {
    const timestamp = generateCreationTimestamp(ca, timeType);

    if (!timestamp) {
      return <span className="creation-time-not-found">Not Sent</span>;
    }

    return displayDateTime(timestamp, "YYYY-MM-DD HH:mm");
  };

  const handleDownloadReferralLetter = (ca) => async () => {
    setIsDownloadingReferral(true);
    const id = ca.referral_letters?.[0]?.id;
    const name = ca.referral_letters?.[0]?.name;
    if (id && name) {
      const fileId = isDataFromPMS ? name : id; // It is file name in gcs /ai-ocr-referral/<file_name> actually
      const res = await fetchReferralLetter(fileId);
      downloadReferralLetter([res.data], name);
    }
    setIsDownloadingReferral(false);
  };

  useEffect(() => {
    let filters = [];
    !_.isEmpty(clientFilter) && filters.push(usernameFieldFilter(clientFilter));
    !_.isEmpty(dobFilter) && filters.push(dateFieldFilter(dobFilter, "client.dateOfBirth"));
    !_.isEmpty(creationDateTimeFilter) && filters.push(creationDateTimeFieldFilter(creationDateTimeFilter, timeType));
    !_.isEmpty(referrerFilter) && filters.push(referrerFieldFilter(referrerFilter, referrers));
    !_.isEmpty(caseManagerFilter) && filters.push(caseManagerFieldFilter(caseManagerFilter, practitioners));
    !_.isEmpty(clinicFilter) && filters.push(generalFieldFilter(clinicFilter, "clinic.name"));
    !_.isEmpty(appointmentDateFilter) && filters.push(appointmentDateFieldFilter(appointmentDateFilter));
    !_.isEmpty(appointmentFilter) && filters.push(generalFieldFilter(appointmentFilter, "appointment_t.coordinator"));
    !_.isEmpty(preConsultFilter) && filters.push(generalFieldFilter(preConsultFilter, "pre_consult_t.coordinator"));
    !_.isEmpty(letterFilter) && filters.push(generalFieldFilter(letterFilter, "letter_t.coordinator"));
    !_.isEmpty(bookingStatusFilter) && filters.push(generalFieldFilter(bookingStatusFilter, "bookingStatus"));
    let newCaData = filters.reduce((caData, filter) => filter(caData), clientAppointmentRequests);

    const generateSortOrder = () => sortColumns.map(({ order }) => (order ? "asc" : "desc"));
    const generateSortColumnsIterates = () => {
      const mappings = {
        creationTimestamp: (ca) => generateCreationTimestamp(ca, timeType),
        client: (ca) => `${_.get(ca, "client.firstName", "")} ${_.get(ca, "client.lastName", "")}`,
        dob: (ca) => ca.client.dateOfBirth,
        referrer: (ca) => getReferrerFullName(ca, referrers),
        practitioner: (ca) => getCaseManagerById(ca, practitioners),
        clinic: (ca) => _.get(ca, "clinic.name", ""),
        appointment: (ca) =>
          formatDateTime(
            _.get(ca, `appointment.startDateTime`, _.get(ca, `pendingAppointment.startDateTime`, "")),
            true,
            true
          ),
        appointment_t: (ca) => [
          getRemainingWeeksToAppointment(ca),
          _.get(ca, "appointment_t.status", ""),
          _.get(ca, "appointment_t.coordinator", ""),
        ],
        letter_t: (ca) => [_.get(ca, "letter_t.status", ""), _.get(ca, "letter_t.coordinator", "")],
        pre_consult_t: (ca) => [_.get(ca, "pre_consult_t.status", ""), _.get(ca, "pre_consult_t.coordinator", "")],
        bookingStatus: (ca) => {
          const bookingStatus = _.get(ca, "bookingStatus", "");
          switch (bookingStatus) {
            case BOOKING_STATUS.APPROVED:
              return 1;
            case BOOKING_STATUS.REJECTED:
              return 2;
            case BOOKING_STATUS.PENDING_APPROVAL:
              return 4;
            default:
              return 3;
          }
        },
      };

      return sortColumns.reduce((columnSorts, { column }) => {
        const columnSort = mappings[column];
        if (columnSort) {
          return [...columnSorts, columnSort];
        }

        return [...columnSorts];
      }, []);
    };

    newCaData = _.orderBy(newCaData, generateSortColumnsIterates(), generateSortOrder());
    setTotalNumOfRows(newCaData.length);
    setTotalPages(Math.ceil(newCaData.length / pageSize));
    setPageFrom(currentPageIndex * pageSize + 1);

    const offset = newCaData.length % pageSize;
    const offsetPageSize = offset === 0 ? pageSize : offset;
    setPageTo(
      currentPageIndex === Math.ceil(newCaData.length / pageSize) - 1
        ? currentPageIndex * pageSize + offsetPageSize
        : currentPageIndex * pageSize + pageSize
    );
    setCaData(newCaData.slice(currentPageIndex * pageSize, currentPageIndex * pageSize + pageSize));
  }, [
    clientAppointmentRequests,
    clientFilter,
    dobFilter,
    creationDateTimeFilter,
    appointmentDateFilter,
    appointmentFilter,
    preConsultFilter,
    letterFilter,
    bookingStatusFilter,
    referrerFilter,
    caseManagerFilter,
    clinicFilter,
    currentPageIndex,
    pageSize,
    practitioners,
    referrers,
    timeType,
    sortColumns,
  ]);

  return (
    <div className="workflow">
      <div className={`${openModal ? "is-active " : ""}modal`}>
        <div className="modal-background form" onClick={handleCloseModal} />
        <div className="modal-content">
          <div className="box is-radiusless is-size-7">
            {!_.isNull(actionSuccess) && (
              <article className={`${actionSuccess ? "is-success " : "is-danger "}message is-size-7`}>
                <div className="message-body is-radiusless">{actionSuccess ? "action completed" : "action failed"}</div>
              </article>
            )}
            {modalFormName === "add_appointment" && (
              <AppointmentForm
                clientAppointmentId={_.get(activeCa, "id", "")}
                workflowName={WORKFLOW_NAME.APT_REQUESTS}
                isNewAppointment={_.get(activeCa, "appointment_t.is_new_appointment", false)}
                appointment={_.get(
                  _.find(clientAppointmentRequests, (ca) => ca.id === activeCaId),
                  "appointment",
                  _.get(
                    _.find(clientAppointmentRequests, (ca) => ca.id === activeCaId),
                    "pendingAppointment",
                    null
                  )
                )}
                preConsult={_.get(
                  _.find(clientAppointmentRequests, (ca) => ca.id === activeCaId),
                  "pre_consult_t",
                  null
                )}
                isRTNoteFilled={_.get(
                  _.find(clientAppointmentRequests, (ca) => ca.id === activeCaId),
                  "pre_consult_t.notes",
                  false
                )}
                selectedPractitioner={_.get(
                  _.find(clientAppointmentRequests, (ca) => ca.id === activeCaId),
                  "practitioner",
                  null
                )}
                referralEmail={_.get(
                  _.find(clientAppointmentRequests, (ca) => ca.id === activeCaId),
                  "referral.referrerLocation.email",
                  null
                )}
                referralExpiredDate={
                  _.has(
                    _.find(clientAppointmentRequests, (ca) => ca.id === activeCaId),
                    "referral.endDate"
                  )
                    ? moment(
                        _.get(
                          _.find(clientAppointmentRequests, (ca) => ca.id === activeCaId),
                          "referral.endDate"
                        )
                      )
                    : null
                }
                submit={handleAddAppointment(BOOKING_STATUS.APPROVED)}
                inform={handleInformDeletion}
                caseManager={_.get(activeCa, "practitioner", null)}
                specialty={_.get(activeCa, "specialty", "")}
                remove={handleDeleteAppointment(_.get(activeCa, "id", ""))}
                client={_.get(activeCa, "client", {})}
                clinic={_.get(activeCa, "clinic", null)}
                practitioners={practitioners}
                isLoading={inAction}
                actionName="Create"
              />
            )}
            {modalFormName === "manage_tasks" && (
              <ManageTasksForm
                submit={handleManageTasks(_.get(activeCa, "id", ""))}
                isLoading={inAction}
                caTasks={getTasks()}
              />
            )}
            {modalFormName === "delete_apt" && (
              <DeleteWorkflowForm
                id={activeCaId}
                appointment={_.get(
                  _.find(clientAppointmentRequests, (ca) => ca.id === activeCaId),
                  "appointment",
                  null
                )}
                closeModal={() => setOpenModal(false)}
              />
            )}
            {_.isEmpty(modalFormName) && (
              <div>
                <span className="icon">
                  <i className="fas fa-cog fa-spin fa-lg" />
                </span>
                <span style={{ verticalAlign: "text-bottom" }}> loading ...</span>
              </div>
            )}
          </div>
        </div>
        <button className="modal-close is-large has-background-primary" aria-label="close" onClick={handleCloseModal} />
      </div>
      <div className="ca-table">
        <div className="level-left">
          <button
            className="button is-primary clear-button is-radiusless is-size-7"
            aria-label="close"
            onClick={handleClearAllSorts}
          >
            Clear All Sorting Options
          </button>
        </div>
        <table className="table is-hoverable is-narrow is-size-7 apt-request-table">
          <thead>
            <tr>
              <th onClick={() => handleSortingClick("client")}>
                <span>Client</span>
                {renderOrderArrow("clint")}
              </th>
              <th onClick={() => handleSortingClick("dob")}>
                <span>DOB</span>
                {renderOrderArrow("dob")}
              </th>
              <th className="time-container">
                <div className="label-container" onClick={() => handleSortingClick("creationTimestamp")}>
                  <span>{timeType}</span>
                  {renderOrderArrow("creationTimestamp")}
                </div>
                <div
                  className="dropdown dropdown-container"
                  onClick={() => setDisplayDropdownList(!displayDropdownList)}
                >
                  <div className="dropdown-trigger">
                    <button className="button" aria-haspopup="true" aria-controls="dropdown-menu">
                      <span className="icon is-small">
                        <i className="fas fa-angle-down" aria-hidden="true" />
                      </span>
                    </button>
                  </div>
                  <div
                    className={`dropdown-menu ${displayDropdownList ? "dropdown-menu-is-active" : ""}`}
                    id="dropdown-menu"
                    role="menu"
                  >
                    <div className="dropdown-content">
                      <div onClick={() => setTimeType(CREATION_TIME_SECTION.FIRST_SMS_TIME)} className="dropdown-item">
                        {CREATION_TIME_SECTION.FIRST_SMS_TIME}
                      </div>
                      <div onClick={() => setTimeType(CREATION_TIME_SECTION.CREATION_TIME)} className="dropdown-item">
                        {CREATION_TIME_SECTION.CREATION_TIME}
                      </div>
                    </div>
                  </div>
                </div>
              </th>
              <th onClick={() => handleSortingClick("referrer")}>
                <span>Referrer</span>
                {renderOrderArrow("referrer")}
              </th>
              <th onClick={() => handleSortingClick("practitioner")}>
                <span>Case Manager</span>
                {renderOrderArrow("practitioner")}
              </th>
              <th onClick={() => handleSortingClick("speciality")}>
                <span>Speciality</span>
                {renderOrderArrow("speciality")}
              </th>
              <th onClick={() => handleSortingClick("clinic")}>
                <span>Clinic</span>
                {renderOrderArrow("clinic")}
              </th>
              <th onClick={() => handleSortingClick("appointment")}>
                <span>APT Date</span>
                {renderOrderArrow("appointment")}
              </th>
              <th onClick={() => handleSortingClick("appointment_t")}>
                <span>Bookings</span>
                {renderOrderArrow("appointment_t")}
              </th>
              <th onClick={() => handleSortingClick("pre_consult_t")}>
                <span>Results</span>
                {renderOrderArrow("pre_consult_t")}
              </th>
              <th onClick={() => handleSortingClick("letter_t")}>
                <span>Notes</span>
                {renderOrderArrow("letter_t")}
              </th>
              <th onClick={() => handleSortingClick("bookingStatus")}>
                <span>Booking Status</span>
                {renderOrderArrow("bookingStatus")}
              </th>
            </tr>
          </thead>
          <tfoot>
            <tr>
              <td colSpan={12}>
                <div className="level">
                  <div className="level-right" />
                  <div className="level-right">
                    <div className="level-item">Rows per page:</div>
                    <div className="level-item">
                      <div className="field">
                        <div className="control">
                          <div className="select is-small">
                            <select
                              className="is-radiusless"
                              onChange={(e) => {
                                setCurrentPageIndex(0);
                                setPageSize(Number(e.target.value));
                              }}
                              value={pageSize}
                            >
                              <option value="10">10</option>
                              <option value="20">20</option>
                              <option value="30">30</option>
                              <option value="40">40</option>
                              <option value="50">50</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="level-item mx-4">
                      <span>{pageFrom}</span>
                      <span className="mx-1">-</span>
                      <span>{pageTo}</span>
                      <span className="mx-1">of</span>
                      <span>{totalNumOfRows}</span>
                    </div>
                    <div className="level-item mx-4">
                      <div className="go-start" onClick={() => setCurrentPageIndex(0)}>
                        <span className="icon is-medium has-text-primary">
                          <i className="fas fa-step-backward fa-lg" />
                        </span>
                      </div>
                      <div
                        className="go-previous"
                        onClick={() => {
                          setCurrentPageIndex((i) => (i === 0 ? i : i - 1));
                        }}
                      >
                        <span className="icon is-medium has-text-primary">
                          <i className="fas fa-chevron-left fa-lg" />
                        </span>
                      </div>
                      <div
                        className="go-next"
                        onClick={() =>
                          setCurrentPageIndex((i) => {
                            return i === totalPages - 1 ? i : i + 1;
                          })
                        }
                      >
                        <span className="icon is-medium has-text-primary">
                          <i className="fas fa-chevron-right fa-lg" />
                        </span>
                      </div>
                      <div className="go-end" onClick={() => setCurrentPageIndex(totalPages - 1)}>
                        <span className="icon is-medium has-text-primary">
                          <i className="fas fa-step-forward fa-lg" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tfoot>
          <tbody>
            <tr>
              <td>
                <input
                  className="input is-radiusless is-small"
                  type="text"
                  value={clientFilter}
                  onChange={(e) => {
                    setCurrentPageIndex(0);
                    setClientFilter(e.target.value);
                  }}
                />
              </td>
              <td>
                <input
                  className="input is-radiusless is-small"
                  type="text"
                  value={dobFilter}
                  onChange={(e) => {
                    setCurrentPageIndex(0);
                    setDobFilter(e.target.value);
                  }}
                />
              </td>
              <td>
                <input
                  className="input is-radiusless is-small"
                  type="text"
                  value={creationDateTimeFilter}
                  onChange={(e) => {
                    setCurrentPageIndex(0);
                    setCreationDateTimeFilter(e.target.value);
                  }}
                />
              </td>
              <td>
                <input
                  className="input is-radiusless is-small"
                  type="text"
                  value={referrerFilter}
                  onChange={(e) => {
                    setCurrentPageIndex(0);
                    setReferrerFilter(e.target.value);
                  }}
                />
              </td>
              <td>
                <input
                  className="input is-radiusless is-small"
                  type="text"
                  value={caseManagerFilter}
                  onChange={(e) => {
                    setCurrentPageIndex(0);
                    setCaseManagerFilter(e.target.value);
                  }}
                />
              </td>
              <td>
                <input
                  className="input is-radiusless is-small"
                  type="text"
                  value={specialityFilter}
                  onChange={(e) => {
                    setCurrentPageIndex(0);
                    setSpecialityFilter(e.target.value);
                  }}
                />
              </td>
              <td>
                <input
                  className="input is-radiusless is-small"
                  type="text"
                  value={clinicFilter}
                  onChange={(e) => {
                    setCurrentPageIndex(0);
                    setClinicFilter(e.target.value);
                  }}
                />
              </td>
              <td>
                <input
                  className="input is-radiusless is-small"
                  type="text"
                  value={appointmentDateFilter}
                  onChange={(e) => {
                    setCurrentPageIndex(0);
                    setAppointmentDateFilter(e.target.value);
                  }}
                />
              </td>
              <td>
                <input
                  className="input is-radiusless is-small"
                  type="text"
                  value={appointmentFilter}
                  onChange={(e) => {
                    setCurrentPageIndex(0);
                    setAppointmentFilter(e.target.value);
                  }}
                />
              </td>
              <td>
                <input
                  className="input is-radiusless is-small"
                  type="text"
                  value={preConsultFilter}
                  onChange={(e) => {
                    setCurrentPageIndex(0);
                    setPreConsultFilter(e.target.value);
                  }}
                />
              </td>
              <td>
                <input
                  className="input is-radiusless is-small"
                  type="text"
                  value={letterFilter}
                  onChange={(e) => {
                    setCurrentPageIndex(0);
                    setLetterFilter(e.target.value);
                  }}
                />
              </td>
              <td>
                <input
                  className="input is-radiusless is-small"
                  type="text"
                  value={bookingStatusFilter}
                  onChange={(e) => {
                    setCurrentPageIndex(0);
                    setBookingStatusFilter(e.target.value);
                  }}
                />
              </td>
            </tr>
            {caData.map((ca, index) => {
              const remainingWeeksToAppointment = getRemainingWeeksToAppointment(ca);
              const newOrReview = _.get(ca, "appointment_t.is_new_appointment", false) ? "N" : "R";
              const renderBookingStatus = (bookingStatus) => {
                switch (bookingStatus) {
                  case BOOKING_STATUS.APPROVED:
                    return <span className="tag is-success is-radiusless"> {BOOKING_STATUS.APPROVED} </span>;
                  case BOOKING_STATUS.PENDING_APPROVAL:
                    return <span className="tag is-warning is-radiusless"> {BOOKING_STATUS.PENDING_APPROVAL} </span>;
                  case BOOKING_STATUS.REJECTED:
                    return <span className="tag is-danger is-radiusless"> {BOOKING_STATUS.REJECTED} </span>;
                  default:
                    return <span className="tag is-dark is-radiusless"> {bookingStatus} </span>;
                }
              };
              return (
                <Fragment key={ca.id}>
                  <tr className={ca.id === activeCaId ? "is-active" : ""} onClick={() => handleClickRow(ca.id)}>
                    <td>
                      <div>{`${_.get(ca, "client.firstName", "")} ${_.get(ca, "client.lastName", "")}`}</div>
                      <div className="level">
                        <div className="level-left">
                          <div className="level-item">
                            <span className="has-text-info">{`${_.get(ca, "client.phoneNumberMobile", "")}`}</span>
                          </div>
                          {_.has(ca, "email_notifications.patient") && (
                            <div className="level-item">
                              <span className="icon is-small has-text-primary">
                                <i className="fas fa-envelope" />
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    </td>
                    <td>{moment(_.get(ca, "client.dateOfBirth", ""), "YYYY-MM-DD").format("DD/MM/YYYY")}</td>
                    <td>
                      {renderCreationTimeSection(ca)}
                      <div>{renderManualSMSStatus(ca.id)}</div>
                    </td>
                    <td>
                      <div>{getReferrerFullName(ca, referrers)}</div>
                      <div className="referrer-info">
                        {_.has(ca, "email_notifications.referrer") && (
                          <span className="icon is-small has-text-primary">
                            <i className="fas fa-envelope" />
                          </span>
                        )}
                        {!_.isNil(ca?.referral_letters) && (
                          <span
                            key={isDownloadingReferral}
                            className="icon is-small has-text-primary"
                            onClick={handleDownloadReferralLetter(ca)}
                          >
                            <i className={`fas${isDownloadingReferral ? " fa-spinner fa-pulse" : " fa-download"}`} />
                          </span>
                        )}
                        <div>
                          {_.has(ca, "referral.endDate")
                            ? displayDateTime(_.get(ca, "referral.endDate"), "YYYY-MM-DD HH:mm")
                            : null}
                        </div>
                      </div>
                    </td>
                    <td>
                      {(_.has(ca, "practitioner.id") || _.has(ca, "practitioner.practitionerId")) && (
                        <div>{getCaseManagerById(ca, practitioners, practitionerPreferences)}</div>
                      )}
                      {_.has(ca, "email_notifications.practitioner") && (
                        <div>
                          <span className="icon is-small has-text-primary">
                            <i className="fas fa-envelope" />
                          </span>
                        </div>
                      )}
                    </td>
                    <td>
                      {(_.has(ca, "practitioner.id") || _.has(ca, "practitioner.practitionerId")) && (
                        <div>
                          {practitionerPreferences.find(
                            ({ practitionerId }) => ca.practitioner.practitionerId === practitionerId
                          )?.speciality?.name || ""}
                        </div>
                      )}
                    </td>
                    <td>
                      <div>{_.get(ca, "clinic.name", "")}</div>
                      <div className="has-text-info">{_.get(ca, "clinic.phone", "")}</div>
                    </td>
                    <td>
                      {(_.has(ca, "appointment.startDateTime") &&
                        formatDateTime(ca.appointment.startDateTime, true, false)) ||
                        (_.has(ca, "pendingAppointment.startDateTime") &&
                          formatDateTime(_.get(ca, "pendingAppointment.startDateTime"), true, false))}
                      <div>
                        {getReceivedYesStatus(ca.id)}
                        {renderIVRIcon(ca.id)}
                      </div>
                    </td>
                    <td>
                      <div className={`${index === caData.length - 1 ? "is-up " : ""}dropdown is-hoverable is-right`}>
                        <div className="dropdown-trigger">
                          <div className="level" onClick={() => handleClickManageTasks(ca.id)}>
                            <div
                              className={`task-btn level-item px-2 ${getTaskStatusClasses(
                                _.get(ca, "appointment_t.status", "")
                              )}`}
                            >
                              {_.get(ca, "appointment_t.coordinator", false) || "++"}
                            </div>
                            <div className="level-item pl-2">{newOrReview}</div>
                            <div className="level-item pl-2">{remainingWeeksToAppointment}</div>
                            {_.get(ca, "appointment_t.urgent", false) && (
                              <div className="level-item">
                                <span className="icon has-text-danger-dark">
                                  <i className="fas fa-exclamation-triangle" />
                                </span>
                              </div>
                            )}
                            {_.get(ca, "appointment_t.triage", false) && (
                              <div className="level-item">
                                <span className="icon has-text-info-dark">
                                  <i className="fas fa-stethoscope" />
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                        {_.get(ca, "appointment_t.notes", "") && (
                          <div className="dropdown-menu">
                            <div className="dropdown-content px-2 is-size-7 is-radiusless has-background-info has-text-white">
                              {_.get(ca, "appointment_t.notes", "")}
                            </div>
                          </div>
                        )}
                      </div>
                    </td>
                    <td>
                      <div className={`${index === caData.length - 1 ? "is-up " : ""}dropdown is-hoverable is-right`}>
                        <div className="dropdown-trigger">
                          <div className="level" onClick={() => handleClickManageTasks(ca.id)}>
                            <div
                              className={`task-btn level-item px-2 ${getTaskStatusClasses(
                                _.get(ca, "pre_consult_t.status", "")
                              )}`}
                            >
                              {_.get(ca, "pre_consult_t.coordinator", false) || "++"}
                            </div>
                            {_.get(ca, "pre_consult_t.urgent", false) && (
                              <div className="level-item">
                                <span className="icon has-text-danger-dark">
                                  <i className="fas fa-exclamation-triangle" />
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                        {_.get(ca, "pre_consult_t.notes", "") && (
                          <div className="dropdown-menu">
                            <div className="dropdown-content px-2 is-size-7 is-radiusless has-background-info has-text-white">
                              {_.get(ca, "pre_consult_t.notes", "")}
                            </div>
                          </div>
                        )}
                      </div>
                    </td>
                    <td>
                      <div className={`${index === caData.length - 1 ? "is-up " : ""}dropdown is-hoverable is-right`}>
                        <div className="dropdown-trigger">
                          <div className="level" onClick={() => handleClickManageTasks(ca.id)}>
                            <div
                              className={`task-btn level-item px-2 ${getTaskStatusClasses(
                                _.get(ca, "letter_t.status", "")
                              )}`}
                            >
                              {_.get(ca, "letter_t.coordinator", false) || "++"}
                            </div>
                            {_.get(ca, "letter_t.urgent", false) && (
                              <div className="level-item">
                                <span className="icon has-text-danger-dark">
                                  <i className="fas fa-exclamation-triangle" />
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                        {_.get(ca, "letter_t.notes", "") && (
                          <div className="dropdown-menu">
                            <div className="81 px-2 is-size-7 is-radiusless has-background-info has-text-white">
                              {_.get(ca, "letter_t.notes", "")}
                            </div>
                          </div>
                        )}
                      </div>
                    </td>
                    <td>
                      <div>{renderBookingStatus(_.get(ca, "bookingStatus", ""))}</div>
                    </td>
                  </tr>
                  {ca.id === activeCaId && (
                    <>
                      <tr className="is-active">
                        <td colSpan={12}>
                          <div className="tabs is-small is-toggle">
                            <ul>
                              {_.map(aptRequestClientTab, (tab) => (
                                <li
                                  key={tab.id}
                                  className={`${workflowSelectedTabId === tab.id ? "is-active " : ""}is-size-7`}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setWorkflowSelectedTabId(tab.id);
                                  }}
                                >
                                  {
                                    // eslint-disable-next-line
                                    <a className="is-radiusless">
                                      <span>{tab.label}</span>
                                    </a>
                                  }
                                </li>
                              ))}
                            </ul>
                          </div>
                        </td>
                      </tr>
                      <tr className="is-active">
                        <td colSpan={12}>
                          {workflowSelectedTabId === "logs" && (
                            <div className="columns is-shadowless is-radiusless is-4">
                              <div className="column sms-logs box">
                                <div>Appointment notification SMS</div>
                                {getSMSLogsWithHistory(activeCa.id, clientAppointmentRequests, "sms").map(
                                  (sms, idx) => (
                                    <div key={idx}>
                                      [{displayTimestamp(sms.ts)}] {sms.text}
                                    </div>
                                  )
                                )}
                              </div>
                              <div className="column sms-logs box">
                                <div>Manual SMS</div>
                                {getSMSLogs(activeCa.id, clientAppointmentRequests, "manual_sms").map((sms, idx) => (
                                  <div key={idx}>
                                    [{displayTimestamp(sms.ts)}] {sms.text}
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}
                          {workflowSelectedTabId === "sms" && (
                            <div>
                              <ManualSms isSending={inAction} onSend={(message) => handleSendSMSMessage(message)} />
                            </div>
                          )}
                          <div className="field is-grouped">
                            <p className="control">
                              {_.has(
                                _.find(clientAppointmentRequests, (ca) => ca.id === activeCaId),
                                "pendingAppointment"
                              ) &&
                                activeCa.bookingStatus !== BOOKING_STATUS.APPROVED && (
                                  <button
                                    className="button is-info is-outlined is-small is-radiusless"
                                    onClick={() => handleClickAddAppointment()}
                                  >
                                    Approve
                                  </button>
                                )}
                            </p>
                            <p className="control">
                              <button
                                className="button is-danger is-outlined is-small is-radiusless"
                                onClick={handleClickDelete}
                              >
                                Delete Workflow
                              </button>
                            </p>
                          </div>
                          <div>{ca.id}</div>
                        </td>
                      </tr>
                    </>
                  )}
                </Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(AppointmentRequests);
